function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrac(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_3",
    "data-name": "Layer 3",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 82 82",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M5,10.91V70.78H78V10.91ZM76,68.78H7V12.91H76Z",
    style: {
      fill: "currentColor",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.83,25.53l50.05,0a1.83,1.83,0,0,1,2,2,2,2,0,0,1-2,1.91l-52.31,0v2l52.31,0a4,4,0,0,0,4-3.91,3.81,3.81,0,0,0-4-4h0l-50,0a2,2,0,0,1-2-1.91,1.85,1.85,0,0,1,2-2H68.61v-2H15.83a3.8,3.8,0,0,0-4,4A4,4,0,0,0,15.83,25.53Z",
    style: {
      fill: "currentColor",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.64,66.67A15.88,15.88,0,1,0,8.76,50.79,15.91,15.91,0,0,0,24.64,66.67Zm0-29.76A13.88,13.88,0,1,1,10.76,50.79,13.9,13.9,0,0,1,24.64,36.91Z",
    style: {
      fill: "currentColor",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.81,50.79A3.83,3.83,0,1,0,24.64,47,3.83,3.83,0,0,0,20.81,50.79Zm5.66,0A1.83,1.83,0,1,1,24.64,49,1.82,1.82,0,0,1,26.47,50.79Z",
    style: {
      fill: "currentColor",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.06,43.51a3.9,3.9,0,0,1,1.75,2.74h2a5.84,5.84,0,0,0-2.55-4.34,6.28,6.28,0,0,0-4.92-1.34l.46,2A4.31,4.31,0,0,1,21.06,43.51Z",
    style: {
      fill: "currentColor",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.56,58.17a4,4,0,0,1-1.74-2.76h-2a5.88,5.88,0,0,0,2.52,4.36,6.67,6.67,0,0,0,4.07,1.45,5,5,0,0,0,.84-.07l-.43-2A4.29,4.29,0,0,1,28.56,58.17Z",
    style: {
      fill: "currentColor",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.58,50.27a4,4,0,0,1,3.26-.09l1-1.72a5.85,5.85,0,0,0-5-.05,6.3,6.3,0,0,0-3.69,3.52l1.9.62A4.3,4.3,0,0,1,16.58,50.27Z",
    style: {
      fill: "currentColor",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.75,51.47l-1,1.71a5.21,5.21,0,0,0,2.51.59,7,7,0,0,0,2.53-.5,6.28,6.28,0,0,0,3.71-3.5l-1.9-.64A4.31,4.31,0,0,1,33,51.41,3.92,3.92,0,0,1,29.75,51.47Z",
    style: {
      fill: "currentColor",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.26,57.42a6.3,6.3,0,0,0,1.22,4.95L21,61a4.35,4.35,0,0,1-.73-3.34,3.94,3.94,0,0,1,1.54-2.87l-1-1.74A5.82,5.82,0,0,0,18.26,57.42Z",
    style: {
      fill: "currentColor",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.35,44.27a6.22,6.22,0,0,0-1.19-5l-1.49,1.33a4.29,4.29,0,0,1,.7,3.34,4,4,0,0,1-1.55,2.86l1,1.75A5.84,5.84,0,0,0,31.35,44.27Z",
    style: {
      fill: "currentColor",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.33,34.91A15.88,15.88,0,1,0,74.21,50.79,15.9,15.9,0,0,0,58.33,34.91Zm0,29.76A13.88,13.88,0,1,1,72.21,50.79,13.89,13.89,0,0,1,58.33,64.67Z",
    style: {
      fill: "currentColor",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.16,50.79a3.83,3.83,0,1,0-3.83,3.82A3.84,3.84,0,0,0,62.16,50.79Zm-3.83,1.82a1.83,1.83,0,1,1,1.83-1.82A1.82,1.82,0,0,1,58.33,52.61Z",
    style: {
      fill: "currentColor",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.75,43.51a3.94,3.94,0,0,1,1.76,2.74h2A5.88,5.88,0,0,0,56,41.91,6.29,6.29,0,0,0,51,40.57l.44,2A4.29,4.29,0,0,1,54.75,43.51Z",
    style: {
      fill: "currentColor",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.25,58.17a3.91,3.91,0,0,1-1.73-2.76h-2A5.84,5.84,0,0,0,61,59.76a6.63,6.63,0,0,0,4.06,1.45,5.39,5.39,0,0,0,.85-.07l-.43-2A4.32,4.32,0,0,1,62.25,58.17Z",
    style: {
      fill: "currentColor",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.53,50.18l1-1.72a5.84,5.84,0,0,0-5-.05,6.3,6.3,0,0,0-3.69,3.52l1.9.62a4.38,4.38,0,0,1,2.54-2.28A3.93,3.93,0,0,1,53.53,50.18Z",
    style: {
      fill: "currentColor",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.45,51.47l-1,1.71a5.1,5.1,0,0,0,2.5.59,7,7,0,0,0,2.53-.5,6.24,6.24,0,0,0,3.71-3.5l-1.89-.64a4.35,4.35,0,0,1-2.55,2.28A3.92,3.92,0,0,1,63.45,51.47Z",
    style: {
      fill: "currentColor",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52,57.42a6.29,6.29,0,0,0,1.23,4.95L54.66,61a4.35,4.35,0,0,1-.73-3.34,3.94,3.94,0,0,1,1.54-2.87l-1-1.74A5.82,5.82,0,0,0,52,57.42Z",
    style: {
      fill: "currentColor",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.05,44.27a6.25,6.25,0,0,0-1.2-5l-1.49,1.33A4.32,4.32,0,0,1,63.07,44a4,4,0,0,1-1.56,2.86l1,1.75A5.87,5.87,0,0,0,65.05,44.27Z",
    style: {
      fill: "currentColor",
      stroke: "none"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrac);
export default __webpack_public_path__ + "static/media/crac.84ef65479f35bae544f49f2602cd14ff.svg";
export { ForwardRef as ReactComponent };